import { customColour } from "../data/colour";

const headerBox = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: `linear-gradient(
    to right bottom,
    rgba(248, 248, 255, 0.2),
    rgba(248, 248, 255, 0.05)
  )`,
  backdropFilter: "blur(1rem)",
  zIndex: 1000,
  margin: "auto",
  boxShadow: "0 0 1rem rgba(0, 0, 0, 0.2)",
};

const dataHeaderBox = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#ebecf0",
  // background: "transparent",
  // backdropFilter: "blur(1rem)",
  zIndex: 1000,
  margin: "auto",
  boxShadow: "0 0 0.25rem rgba(151, 160, 170, 0.1)",
};

const slideDown = {
  transform: "translateY(0)", // Slide down to visible position
  opacity: 1, // Fully visible
};

const slideUp = {
  transform: "translateY(-100%)", // Slide up to hidden position
  opacity: 0, // Hidden
};

const backdropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay effect
  zIndex: 998, // Below the menu box but above other content
  opacity: 1,
  transition: "opacity 0.5s ease",
  display: "flex",
};

const mobileMenuBox = {
  position: "fixed",
  top: "49px", // Position below the fixed header
  left: 0,
  width: "100vw",
  background: `linear-gradient(
    to right bottom,
    rgba(248, 248, 255, 0.2),
    rgba(248, 248, 255, 0.05)
  )`,
  backdropFilter: "blur(1rem)",
  zIndex: 999,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "0 0 1rem rgba(0, 0, 0, 0.2)",
  transition: "transform 0.5s ease, opacity 0.5s ease",
};

const mobileMenuItem = {
  width: "100%", // Full width to match dropdown
  textAlign: "center",
  color: customColour.white,
  mixBlend: "difference",
  textTransform: "uppercase",
  fontSize: "1rem",
  fontWeight: "100",
  borderBottom: `0.5px solid ${customColour.grey}`, // Divider between items
  textDecoration: "none",
};

const footerBox = {
  display: "grid",
  gridTemplateRows: "1fr 2fr",
  width: "auto",
};

const lowerFooterBox = {
  display: "grid",
  width: "auto",
  gridTemplateColumns: "repeat(3, 1fr)",
  color: customColour.white,
};

const menuBox = {
  flex: 1,
  textAlign: "center",
  textDecoration: "none",
  "&:hover": {
    color: customColour.lightBlue,
    textShadow: "0px 0px 20px rgba(55, 166, 222, 0.8)",
    filter: "brightness(1.2)",
  },
};

const buttonBox = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const socialMediaBox = {
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
};

const activeMenuBox = {
  color: customColour.lightBlue,
  fontWeight: "600",
};

export {
  headerBox,
  dataHeaderBox,
  slideDown,
  slideUp,
  backdropStyle,
  mobileMenuBox,
  mobileMenuItem,
  footerBox,
  lowerFooterBox,
  menuBox,
  buttonBox,
  socialMediaBox,
  activeMenuBox,
};
